import {
  Labels,
  Picture,
  OptimizelyEditProperty,
  LinkHeroFrontpage,
} from "/App.Components";
import { HeroFrontpageProps } from "/Models/Generated/HeroFrontpageProps";
import "./HeroFrontpageMaximum.scss";
import { createSpreadableBem } from "/Helpers/createBem";

const HeroFrontpageMaximum = ({
  image,
  imagePropertyName,
  labels,
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  readMoreLink,
  readMoreLinkPropertyName,
}: HeroFrontpageProps) => {
  const bem = createSpreadableBem("hero-frontpage-maximum-norad");
  return (
    <div {...bem("")}>
      <div {...bem("__left")}>
        <div {...bem("__image-container")}>
          <OptimizelyEditProperty propertyName={imagePropertyName}>
            {image && (
              <Picture
                {...image}
                pictureBehaviour="Cover"
                pictureAspectRatio="16/9"
                eagerLoading
              />
            )}
          </OptimizelyEditProperty>
        </div>
      </div>
      <div {...bem("__right")}>
        <div {...bem("__right-container")}>
          {labels && (
            <div {...bem("__tags")}>
              <Labels {...labels} />
            </div>
          )}
          <OptimizelyEditProperty propertyName={headingPropertyName}>
            {heading && (
              <h2
                {...bem("__heading")}
                dangerouslySetInnerHTML={{ __html: heading }}
              ></h2>
            )}
          </OptimizelyEditProperty>
          <OptimizelyEditProperty propertyName={leadTextPropertyName}>
            {leadText && <p {...bem("__lead-text")}>{leadText}</p>}
          </OptimizelyEditProperty>
          <OptimizelyEditProperty propertyName={readMoreLinkPropertyName}>
            {readMoreLink && (
              <div {...bem("__read-more-link-container")}>
                <LinkHeroFrontpage {...readMoreLink} />
              </div>
            )}
          </OptimizelyEditProperty>
        </div>
      </div>
    </div>
  );
};

export default HeroFrontpageMaximum;
